<template>
  <div>
    <img src="static/logo1.png" style="position:absolute;left:14px;top:50px;width:190px;z-index:9999" />

    <img src="static/nav_icon.png" @click="showNavFun()"
      style="position:absolute;right:25px;top:60px;width:20px;z-index:9999" />

    <ul class="navBox" v-if="showNav" style="position:absolute;right:28px;top:68px;text-align:right;z-index:8888">
      <li><router-link to="/">{{ $store.state.language === 'cn' ? '首页' : 'Home' }}</router-link></li>
      <li v-for="type in typeLists" @click="goto(type)" :key="type.typeCode"><a >{{ $store.state.language === 'en' &&
        type.eName ? type.eName :
        type.typeName }}</a></li>
      <li style="color: white;" @click="toggleLanguage">{{ $store.state.language === 'cn' ? 'English' : '中文' }}</li>
    </ul>

  </div>

</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import 'swiper/dist/css/swiper.min.css'
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: 'topNav',
  components:{
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav:false
    }
  },
  computed: {
    ...mapGetters(['typeLists'])
  },
  methods:{
    ...mapActions(['changeLanguage', 'changeType', 'changeSubType']),
      showNavFun(){
       if(this.showNav){
         this.showNav=false;
       }else{
         this.showNav=true;
       }
      },
      toggleLanguage() {
        this.changeLanguage(this.$store.state.language === 'cn' ? 'en' : 'cn');
        window.location.reload();
      },
      goto(type) {
        console.log(type);
        this.changeType(type);
        if (type.subMap.length > 0) {
          this.changeSubType(type.subMap[0]);
          this.$router.replace({ path: `/content/${type.eName.replaceAll(' ','')}/${type.subMap[0].eName?type.subMap[0].eName.replaceAll(' ', ''):''}` });
        }
        else {
          this.$router.replace({path: `/content/${type.eName.replaceAll(' ', '')}`});
        }
        // this.$router.push({path: '/content'});
        
      }

  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navBox {
  width: 210px;
}

.navBox li {
  height: 30px;
  list-style-type: none;
}

.navBox li a {
  color: #fff;
  text-align: right;
  display: block;
  width: 100%;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/topNav.vue